export default __webpack_public_path__ + "static/media/tenence-img.6f56ee61.svg";